import React, {useEffect, useState} from 'react';
import {
    CATEGORIES_PAGE,
    DEFAULT_TEMPLATE_VERSION,
    MOBILE_TEMPLATE_VERSION,
    FIRST_CATEGORY_LEVEL, SECOND_CATEGORY_LEVEL
} from "../../../utils/constants";
import {getBuildId} from "@/utils/communUtil";
import Scripts from "../../Default/Layout/Head/Scripts";
import Script from "next/script";
import {connect} from "react-redux";
import {getTrackingData} from "@/redux/reducers/Default/tracking/trackingActions";
import HeadDetails from "../../Default/Layout/Head";
import Utils from "@/libs/Utils";
import PropTypes from "prop-types";
import {initAppDataKeyValues} from "@/animations/Default/commonPage";
import {BlogCollection} from "./blogCollection";
import {CategoryHeader} from "./categoryHeader";
import {CategoryCarousel} from "./categoryCarousel";
import {CategorySelection} from "./categorySelection";
import {CategoryCtaBlocks} from "./categoryCtaBlocks";
import utils from "@/libs/Utils";
import useFormattedData from "../../../hooks/useFormattedCategoriesData";
import {Breadcrumb} from "../bread-crumb";
import dynamic from "next/dynamic";
import {Olapic} from "./olapic";
import {Target2SellBloc} from "./target2SellBloc";
import IntersectionObserverSSR from "../../Default/Layout/Resource/IntersectionObserverSSR";
import ResponsiveLayout from "../ResponsiveLayout";

const AdsenseBloc = dynamic(
    () => import('@/components/Default/Common/AdsenseBloc'),
    {ssr: false}
)

const CategoriesPage = (props) => {
    const {
        isDQENormalisationActive,
        adsenseStatus,
        context,
        mvcUrl,
        adaptiveLoadingResources,
        shopCircleVersion,
        showBanners,
        bannersBlocList,
        menuItems,
        blogs,
        navigationMetaInfosConfigs,
        octipasPayload,
        trackingUrlFapi,
        mediaContentList,
        aboveMenuItems,
        footerTrackingScopeData,
        headerTrackingScopeData,
        logoVersion,
        googleMapsKey,
        templateVersion,
        metaInfos,
        relatedContents,
        label,
        childrenCategories, categoryLevel, id, parentsCategories,
        getTrackingData
    } = props;
    const [headerCategory, childrenCategory, blogCollection,
        ourSelectionBlocks,
        callToActionBlocks,
        olapicBlocks] =
        useFormattedData({
            label,
            relatedContents,
            childrenCategories,
            categoryLevel,
            metaInfos, mediaContentList, blogCollection: blogs
        });
    const [showMoreCategories, setShowMoreCategories] = useState(false);
    const childrenCategoriesToShow = showMoreCategories
        ? childrenCategories
        : childrenCategories.slice(0, 5);
    useEffect(() => {
        initAppDataKeyValues(navigationMetaInfosConfigs, octipasPayload, trackingUrlFapi, context, mvcUrl, isDQENormalisationActive, shopCircleVersion, logoVersion, templateVersion)
        getTrackingData(mvcUrl)
    }, [])
    const levelsNavigation = [
        {
            id: "1",
            label: label,
        },
    ]
    for (const parentCategory of parentsCategories) {
        levelsNavigation.unshift({
            id: parentCategory.id,
            label: parentCategory.label,
            url: Utils.getMetaInfosValueByCode("SeoUrl", parentCategory.metaInfos),
        });
    }
    return (
        <>
            <HeadDetails
                title={Utils.getMetaInfosValueByCode("METATitle", metaInfos)}
                description={Utils.getMetaInfosValueByCode("METADescription", metaInfos)}
                keywords={Utils.getMetaInfosValueByCode("METAKeywords", metaInfos)}
                canonical={Utils.getMetaInfosValueByCode("canonicalUrl", metaInfos)}>
                <link rel="stylesheet" href={"/assets/css/responsive/style.css?v=" + getBuildId()}/>
                {props.templateVersion === DEFAULT_TEMPLATE_VERSION &&
                    <link rel="stylesheet" href={"/assets/css/default/headerFooter.css?v=" + getBuildId()}/>}
                {props.templateVersion === MOBILE_TEMPLATE_VERSION &&
                    <link rel="stylesheet" href={"/assets/css/mobile/headerFooter.css?v=" + getBuildId()}/>}
                {props.categoryLevel === FIRST_CATEGORY_LEVEL ?
                    <link rel="stylesheet" href={"/assets/css/responsive/category-level1.css?v=" + getBuildId()}/> :
                    <link rel="stylesheet" href={"/assets/css/responsive/category-level2.css?v=" + getBuildId()}/>}
            </HeadDetails>
            <Scripts>
                <Script src="/assets/js/owl.carousel.min.js" strategy="beforeInteractive"/>
                {props.templateVersion === DEFAULT_TEMPLATE_VERSION &&
                    <Script type="text/tc_privacy" data-category="3"
                            src={"/assets/js/Default/octipasMerchLibraryConfig.js?v=" + getBuildId()}/>}
                {props.templateVersion === MOBILE_TEMPLATE_VERSION &&
                    <Script type="text/tc_privacy" data-category="3"
                            src={"/assets/js/octipasMerchLibraryConfig.js?v=" + getBuildId()}/>}
            </Scripts>
            <ResponsiveLayout pathName={'categories'}
                              currentStep={context}
                              context={CATEGORIES_PAGE}
                              headerTrackingScopeData={headerTrackingScopeData}
                              footerTrackingScopeData={footerTrackingScopeData}
                              isDQENormalisationActive={isDQENormalisationActive}
                              shopCircleVersion={shopCircleVersion}
                              googleMapsKey={googleMapsKey}
                              logoVersion={logoVersion}
                              aboveMenuItems={aboveMenuItems}
                              showBanners={showBanners}
                              bannersBlocList={bannersBlocList}
                              menuItems={menuItems}
                              templateVersion={templateVersion}
                              ssr={false}>
                <div className="wrapper">
                    {categoryLevel && (
                        <Breadcrumb levelsNavigation={levelsNavigation} parentsCategories={parentsCategories}
                                    context={context}/>
                    )}
                    <div className="category-content">
                        <CategoryHeader {...headerCategory}/>
                        <div className="category-container">
                            {categoryLevel === FIRST_CATEGORY_LEVEL ? (
                                    childrenCategoriesToShow.map((category, index) => {
                                        if (index === 1) {
                                            return (
                                                <CategoryCarousel
                                                    key={index}
                                                    link={utils.getMetaInfosValueByCode("SeoUrl", category.metaInfos)}
                                                    id={category.id}
                                                    items={category.childrenCategories}
                                                    label={category.label}
                                                />
                                            );
                                        } else {
                                            return (
                                                <IntersectionObserverSSR key={index}>
                                                    <CategoryCarousel
                                                        link={utils.getMetaInfosValueByCode("SeoUrl", category.metaInfos)}
                                                        id={category.id}
                                                        items={category.childrenCategories}
                                                        label={category.label}
                                                    />
                                                </IntersectionObserverSSR>
                                            );
                                        }
                                    }))
                                : (
                                    <CategoryCarousel
                                        id="childrenCategories"
                                        items={childrenCategories}
                                        label={"Tout l'univers " + label}
                                    />
                                )}

                            {childrenCategories.length > 5 && (
                                <div className="category-show-more">
                                    {!showMoreCategories && categoryLevel === FIRST_CATEGORY_LEVEL ? (
                                        <button
                                            className="category-show-more-btn button tertiary"
                                            onClick={() => setShowMoreCategories(!showMoreCategories)}
                                        >
                                            Voir plus de catégories
                                        </button>
                                    ) : null}
                                </div>
                            )}
                            <IntersectionObserverSSR>
                                <BlogCollection items={blogs}/>
                            </IntersectionObserverSSR>
                            {categoryLevel === SECOND_CATEGORY_LEVEL && (
                                <>
                                    <CategorySelection content={ourSelectionBlocks}/>
                                    <CategoryCtaBlocks content={callToActionBlocks}/>
                                </>
                            )}
                            <Target2SellBloc pId={categoryLevel === FIRST_CATEGORY_LEVEL ? '1419' : '1420'}
                                             espaceId={categoryLevel === FIRST_CATEGORY_LEVEL ? '1416' : '1419'}/>
                            {categoryLevel === SECOND_CATEGORY_LEVEL &&
                                <IntersectionObserverSSR>
                                    <Olapic items={olapicBlocks}/>
                                </IntersectionObserverSSR>}
                            {adsenseStatus &&
                                <div align="center">
                                    <AdsenseBloc
                                        style={{
                                            "display": 'block'
                                        }}
                                        resources={adaptiveLoadingResources}
                                        dataAdFormat="auto"
                                        dataFullWidthResponsive="true"
                                        dataAdClient="ca-pub-5844672657887373" dataAdSlot="7657071110"
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </ResponsiveLayout>

        </>
    );
};
CategoriesPage.propTypes =
    {
        context: PropTypes.string,
        mvcUrl: PropTypes.string,
        blogs: PropTypes.object
    };
const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        menuItems: (!state.menu.isDefaultMenu) ? ownProps.menuItems : state.menu.menuItems.values,
        templateVersion: ownProps.templateVersion,
        userId: state.header.webUserId,
        group: state.header.userData?.group
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getTrackingData: (mvcUrl) => dispatch(getTrackingData(mvcUrl))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(CategoriesPage);